import axiosInstance from '../Shared/Utils/axiosInstance';
import { TokenDecrypt } from '../Shared/Utils/encryptionDecryption';

const mappingFunction = (data, value, label) => {
  const decryptedData = TokenDecrypt(data);
  return decryptedData.map((item) => {
    return { value: item[value], label: item[label], ...item };
  });
};

export const getAllStates = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllStates?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'stateId', 'stateName');
    }
    throw new Error('Failed to fetch states');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch states');
  }
};

export const getAllDistricts = async (stateId, languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllDistricts/${stateId}?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'districtId', 'districtName');
    }
    throw new Error('Failed to fetch districts');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch districts');
  }
};

export const getAllTalukas = async (districtId, languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllTalukas/${districtId}?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'talukaId', 'talukaName');
    }
    throw new Error('Failed to fetch talukas');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch talukas');
  }
};

export const getAllPhcs = async (talukaId, languageId, masterType, districtId, roleName, lgbId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllPhcs/${districtId}?languageId=${languageId}&masterName=${masterType}&talukaId=${talukaId}&roleName=${roleName}&lgbId=${lgbId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'phcId', 'phcName');
    }
    throw new Error('Failed to fetch phcs');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch phcs');
  }
};

export const getAllSubcenters = async (phcId, languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllSubcenters/${phcId}?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(
        response.data.data,
        'subcenterId',
        'subcenterName'
      );
    }
    throw new Error('Failed to fetch subcenters');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch subcenters');
  }
};

export const getAllPrograms = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllPrograms?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'programId', 'programName');
    }
    throw new Error('Failed to fetch programs');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch programs');
  }
};
export const getAllActivityGroup = async (languageId, areaId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllActivityGroup?languageId=${languageId}&areaId=${areaId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'activityGroupName', 'activityGroupName');
    }
    throw new Error('Failed to fetch activity groups');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch activity groups');
  }
};

export const getAllSchemes = async (programId, languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllSchemes/${programId}?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'schemeId', 'schemeName');
    }
    throw new Error('Failed to fetch schemes');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch schemes');
  }
};

export const getAllTrainings = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllTrainings?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'trainingId', 'trainingName');
    }
    throw new Error('Failed to fetch trainings');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch trainings');
  }
};

export const getAllLgbs = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllLgbs?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'lgbId', 'lgbName');
    }
    throw new Error('Failed to fetch lgbs');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch lgbs');
  }
};
export const getAllCorporations = async (languageId, districtId, lgbId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllCorporations?langaugeId=${languageId}&districtId=${districtId}&lgbId=${lgbId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'corporation_council_id', 'corporation_coucil_name');
    }
    throw new Error('Failed to fetch Corporations');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch Corporations');
  }
};

export const getAllFaculties = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllFaculties?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'facultyId', 'facultyName');
    }
    throw new Error('Failed to fetch faculties');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch Faculties');
  }
};

export const getAllAreaTypes = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllAreaTypes?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'areaId', 'areaType');
    }
    throw new Error('Failed to fetch area types');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch area types');
  }
};

export const getAllAreaCategories = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllAreaCategories?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(
        response.data.data,
        'areaCategoryId',
        'areaCategory'
      );
    }
    throw new Error('Failed to fetch categories');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch categories');
  }
};

export const getAllVillages = async (subcenterId, languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllVillages/${subcenterId}?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'villageId', 'villageName');
    }
    throw new Error('Failed to fetch villages');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch villages');
  }
};

export const getAllRoles = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/getAllRoles?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, 'roleId', 'roleName');
    }
    throw new Error('Failed to fetch roles');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch roles');
  }
};

export const getAccessLevels = async (languageId) => {
  try {
    const response = await axiosInstance.get(
      `/miniApi/dataAccessLevels?languageId=${languageId}`
    );
    if (response.status === 200 && response.data && response.data) {
      return mappingFunction(response.data, 'id', 'name');
    }
    throw new Error('Failed to fetch Access Levels');
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch Access Levels');
  }
};
